export const hasOwn =
  // 動作環境によっては、Object.hasOwnがnot a functionとなるための処置
  // 開発環境では、Object.hasOwnが常に真になるためeslintのwarningが出るが無視する
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  Object.hasOwn || ((dict, key) => Object.hasOwnProperty.call(dict, key));
